import PropTypes from "prop-types";

import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";

import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";

import { useMaterialUIController } from "context";

function DefaultStatisticsCard({ title, count, color }) {
  const [controller] = useMaterialUIController();
  const { darkMode } = controller;

  return (
    <Card sx={
      {
        "height":"100%", 
        "backgroundColor": color, 
      }}>
        <MDBox p={2}>
        <Grid container>
          <Grid item xs={12}>
            <MDBox lineHeight={1} sx={{"textAlign": "center"}}>
              <MDTypography variant="h5" fontWeight="bold">
                {count}
              </MDTypography>
              <MDTypography variant="subtitle2" fontWeight="regular">
                {title}
              </MDTypography>
            </MDBox>
          </Grid>
        </Grid>
      </MDBox>
      
    </Card>
  );
}

// Typechecking props for the DefaultStatisticsCard
DefaultStatisticsCard.propTypes = {
  title: PropTypes.string.isRequired,
  count: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
};

export default DefaultStatisticsCard;
